import type { FC } from "react";
import { OrderDesignPreview } from "@jasper/shared";
import { OrderDesignReview } from "/@/components/OrderDesignReview";
import type { OrderPageState } from "./useOrderPage";

type OrderDesignContentProps = {
  state: OrderPageState;
};

export const OrderDesignContent: FC<OrderDesignContentProps> = ({ state }) => {
  const { order, refetch, design } = state;

  if (!order) {
    return null;
  }
  if (design.isReviewPending) {
    return <OrderDesignReview orderId={order.id} refetchOrder={refetch} />;
  }
  if (design.latestOrderDesignId) {
    return <OrderDesignPreview orderDesignId={design.latestOrderDesignId} />;
  }
  return null;
};

export const hasOrderDesignToDisplay = ({ design }: OrderPageState): boolean =>
  design.isReviewPending || !!design.latestOrderDesignId;
